/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiFrameSizeMinIcon16Solid = forwardRef('UiFrameSizeMinIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10 1a1 1 0 0 1 1 1v2.5a.5.5 0 0 0 .5.5H14a1 1 0 1 1 0 2h-2.5A2.5 2.5 0 0 1 9 4.5V2a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M2 9a1 1 0 0 0 0 2h2.5a.5.5 0 0 1 .5.5V14a1 1 0 1 0 2 0v-2.5A2.5 2.5 0 0 0 4.5 9H2Z" }),
        React.createElement("path", { d: "M11.5 9A2.5 2.5 0 0 0 9 11.5V14a1 1 0 1 0 2 0v-2.5a.5.5 0 0 1 .5-.5H14a1 1 0 1 0 0-2h-2.5Z" }),
        React.createElement("path", { d: "M7 2a1 1 0 0 0-2 0v2.5a.5.5 0 0 1-.5.5H2a1 1 0 0 0 0 2h2.5A2.5 2.5 0 0 0 7 4.5V2Z" })));
});
